module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921135649_T.80db0848.jpg";